/**
 * Alert presentation. The destination itself comes from the server (`link`): the same notification
 * rows also carry admin destinations, and the portal must never route a partner somewhere their
 * role cannot open.
 */
const TONES = {
  PAYMENT: "emerald",
  TASK: "sky",
  FOLLOW_UP: "amber",
  REMINDER: "amber",
  DOCUMENT_EXPIRY: "rose",
  EVENT: "teal",
};

export const alertTone = (notification) => TONES[notification?.tag] || "neutral";

const KIND_LABELS = {
  REFERRAL_DOC_REQUESTED: "Documents",
  REFERRAL_DOC_SUBMITTED: "Documents",
  REFERRAL_COMMISSION_ACCRUED: "Commission",
  REFERRAL_PAYOUT_PAID: "Payout",
  REFERRAL_ADMIN_MESSAGE: "Message",
  REFERRAL_LEAD_ACTIVATED: "Lead",
  REFERRAL_LEAD_REJECTED: "Lead",
  REFERRAL_LEAD_CLIENT_SUBMITTED: "Lead",
  REFERRAL_PROGRAM_OFFER: "Offer",
  REFERRAL_PROGRAM_TERMS: "Terms",
  REFERRAL_TICKET_OFFICE_UPDATE: "Support",
  TASK_ASSIGNED: "Task",
  TASK_UPDATED: "Task",
  TASK_COMMENT: "Task",
};

export const alertLabel = (notification) =>
  KIND_LABELS[notification?.type] || (notification?.type ? "Update" : "Alert");

/** A count is only worth a badge while it is unread, and past 99 the exact number stops helping. */
export const badgeCount = (count) => {
  const value = Number(count) || 0;
  if (value <= 0) return null;
  return value > 99 ? "99+" : String(value);
};
